import { render, staticRenderFns } from "./ExtensionDetail.vue?vue&type=template&id=257416e8&scoped=true"
import script from "./ExtensionDetail.vue?vue&type=script&lang=js"
export * from "./ExtensionDetail.vue?vue&type=script&lang=js"
import style0 from "./ExtensionDetail.vue?vue&type=style&index=0&id=257416e8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "257416e8",
  null
  
)

export default component.exports